<template lang="pug">
v-container
  //- Popup Create User
  v-dialog(v-model="show_create", max-width="800")
    User
  v-dialog(v-model="show_list_inventories", max-width="800")
    ListInventories(:name="name", :loading="loading_inv", :inventories="inventories" :error="error")
  //- Header
  v-row(align="center", justify="space-between")
    v-col(cols="12", sm="3")
      h2.secondary--text(v-if="user.role.slug == 'vet'") Propietarios
      h2.secondary--text(v-if="user.role.slug == 'admin'") Usuarios
    v-col(cols="12", sm="3")
      v-btn(
        v-if="user.role.slug == 'vet'",
        outlined,
        color="secondary",
        @click="createUser"
      ) Añadir Propietario
      v-btn(
        v-if="user.role.slug == 'admin'",
        outlined,
        color="secondary",
        @click="createUser"
      ) Añadir Usuario
  Table(
    @edit="editUser",
    :loading="loading",
    :headers="headers",
    @delete="eraseUser",
    :searchServer="true",
    @search="searchUser",
    @getPage="getUserPage",
    :items="users.results",
    @listInventories="listInventories"
    :pageCount="users.links.last_page",
    :itemsPerPage="users.links.per_page"
  )
</template>

<script>
import { mapState } from "vuex";
import userAPI from "@/api/user";
import User from "@/components/User.vue";
import Table from "@/components/Table.vue";
import inventoryAPI from "@/api/inventories";
import ListInventories from "@/components/inventories/ListInventories.vue";

export default {
  name: "users",
  components: {
    User,
    Table,
    ListInventories
  },
  async created() {
    if (!this.auth_token) {
      this.$router.push("/auth/login");
    }
    this.getUserPage(1);
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      auth_token: state => state.auth.auth_token,
      users: state => state.users.users
    })
  },
  data() {
    return {
      name: "",
      error: null,
      loading: false,
      inventories: [],
      loading_inv: true,
      show_create: false,
      show_list_inventories: false,
      headers: [
        { text: "#", value: "id" },
        { text: "Nombre(s)", value: "first_name" },
        { text: "Apellido(s)", value: "last_name" },
        { text: "Teléfono", value: "phone_number" },
        { text: "Correo Electrónico", value: "email" },
        { text: "Rol", value: "role.name" },
        { text: "Ciudad", value: "city.name" },
        { text: "País", value: "country.name" },
        { text: "Actiones", value: "actions" }
      ]
    };
  },
  methods: {
    createUser() {
      this.show_create = true;
    },
    async listInventories(user) {
      this.show_list_inventories = true;
      this.name = `${user.first_name} ${user.last_name}`;
      const response = await inventoryAPI.getInventoriesWithoutPagination(
        this.auth_token,
        null,
        null,
        null,
        user.id
      );
      if (response.status) this.inventories = response.data;
      else this.error = response.data;
      this.loading_inv = false;
    },
    async getUserPage(page, email) {
      this.loading = true;
      await this.$store.dispatch("users/getUsers", {
        token: this.auth_token,
        page: page,
        email: email ?? null
      });
      this.loading = false;
    },
    editUser(user) {
      this.$router.push(`/users/${user.username}`);
    },
    async eraseUser(user) {
      this.$swal({
        title: `¿Estas seguro de borrar a ${user.first_name} ${user.last_name}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No"
      }).then(async result => {
        if (result.value) {
          const response = await userAPI.deleteUser(
            this.auth_token,
            user.username
          );
          if (response.status) {
            this.$swal({
              title: "Usuario borrado",
              icon: "success"
            });
            await this.$store.dispatch("users/getUsers", {
              token: this.auth_token,
              page: parseInt(this.users.links.current_page)
            });
          } else {
            this.$swal({
              title: response.data,
              icon: "error"
            });
          }
        }
      });
    },
    async searchUser(email) {
      await this.getUserPage(1, email);
    }
  }
};
</script>

<style></style>
